import { fontSize } from '@atlaskit/theme';
import styled from 'styled-components';

export const RedirectWrapper = styled.div`
  .message {
    font-size: ${fontSize() * 1.5}px;
    font-weight: 600;
  }
`;
